/* PATOYS product page: terms gate, PIN code check, copy link, video facade, mobile sticky bar. No dependencies. */
(function () {
  'use strict';

  var root = document.querySelector('product-info.pt-product');
  if (!root) return;

  /* ---------- Terms & Conditions tick box (same behaviour as the existing live script) ---------- */
  var checkbox = document.getElementById('patoys-terms-checkbox');
  var termsError = document.getElementById('patoys-terms-error');

  function setAgreed() {
    root.classList.toggle('pt-agreed', !!(checkbox && checkbox.checked));
  }

  function showTermsError() {
    if (!checkbox) return;
    if (termsError) termsError.hidden = false;
    var wrap = document.getElementById('patoys-terms-wrapper');
    if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
    checkbox.focus({ preventScroll: true });
  }

  if (checkbox) {
    setAgreed();
    checkbox.addEventListener('change', function () {
      if (checkbox.checked && termsError) termsError.hidden = true;
      setAgreed();
    });

    document.addEventListener(
      'click',
      function (e) {
        if (checkbox.checked) return;
        var t = e.target;
        if (!t || !t.closest) return;
        var scope = t.closest('product-info');
        if (!scope) return;
        var add = t.closest('[name="add"], .product-form__submit');
        var buyNow = t.closest('.shopify-payment-button__button, [data-testid="Checkout-button"]');
        if (add || buyNow) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showTermsError();
        }
      },
      true
    );
  }

  /* ---------- PIN code checker (CSV is fetched on first use) ---------- */
  var pinBox = root.querySelector('[data-pt-pin]');
  if (pinBox) {
    var pinInput = pinBox.querySelector('.pt-pin__input');
    var pinBtn = pinBox.querySelector('[data-pt-pin-check]');
    var pinResult = pinBox.querySelector('.pt-pin__result');
    var textNode = pinBox.querySelector('[data-pt-pin-text]');
    var T = {};
    try {
      T = JSON.parse(textNode.textContent);
    } catch (err) {
      T = {};
    }
    var isLarge = pinBox.getAttribute('data-large') === 'true';
    var csvUrl = pinBox.getAttribute('data-csv');
    var wa = pinBox.getAttribute('data-wa');
    var db = null;
    var loading = null;

    var loadDb = function () {
      if (db) return Promise.resolve(db);
      if (loading) return loading;
      loading = fetch(csvUrl)
        .then(function (r) {
          return r.text();
        })
        .then(function (text) {
          var out = {};
          var lines = text.split('\n');
          for (var i = 1; i < lines.length; i++) {
            var cols = lines[i].split(',');
            if (cols.length >= 4 && cols[0].trim()) {
              out[cols[0].trim()] = { state: cols[1].trim(), city: cols[2].trim(), prepaid: cols[3].trim() };
            }
          }
          db = out;
          return out;
        })
        .catch(function () {
          loading = null;
          return null;
        });
      return loading;
    };

    pinInput.addEventListener('focus', loadDb, { once: true });
    pinInput.addEventListener('input', function () {
      pinInput.value = pinInput.value.replace(/\D/g, '').slice(0, 6);
    });

    var gtag4 = function (name, params) {
      try {
        if (typeof gtag === 'function') gtag('event', name, params);
      } catch (e) {}
    };

    var show = function (kind, nodes) {
      pinResult.hidden = false;
      pinResult.className = 'pt-pin__result pt-pin__result--' + kind;
      pinResult.textContent = '';
      nodes.forEach(function (n) {
        pinResult.appendChild(typeof n === 'string' ? document.createTextNode(n) : n);
      });
    };

    var line = function (text, cls) {
      var p = document.createElement('span');
      p.className = 'pt-pin__line' + (cls ? ' ' + cls : '');
      p.textContent = text;
      return p;
    };

    var waLink = function () {
      var a = document.createElement('a');
      a.href = 'https://wa.me/' + wa;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = T.whatsapp || 'WhatsApp';
      return a;
    };

    var check = function () {
      var pin = pinInput.value.trim();
      if (pin.length !== 6 || isNaN(Number(pin))) {
        show('bad', [line(T.invalid)]);
        return;
      }
      show('wait', [line(T.checking)]);
      gtag4('pincode_checked', { pincode: pin });
      loadDb().then(function (data) {
        if (!data) {
          show('warn', [line(T.unable), ' ', waLink()]);
          return;
        }
        var info = data[pin];
        if (info && info.prepaid === 'Y') {
          var nodes = [line(T.available, 'pt-pin__strong')];
          nodes.push(line(info.city + ', ' + info.state));
          nodes.push(line(isLarge ? T.largeNote : T.smallNote));
          nodes.push(line(T.prepaid, 'pt-pin__warn'));
          show('ok', nodes);
          gtag4('pincode_available', { pincode: pin, city: info.city, state: info.state });
        } else if (info) {
          show('bad', [line(T.unavailable), ' ', waLink()]);
          gtag4('pincode_unavailable', { pincode: pin });
        } else {
          show('warn', [line(T.notFound), ' ', waLink()]);
          gtag4('pincode_not_found', { pincode: pin });
        }
      });
    };

    pinBtn.addEventListener('click', check);
    pinInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        check();
      }
    });
  }

  /* ---------- Copy link ---------- */
  root.querySelectorAll('[data-pt-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-pt-copy');
      var done = btn.getAttribute('data-done');
      var original = btn.textContent;
      var finish = function () {
        btn.textContent = done;
        setTimeout(function () {
          btn.textContent = original;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(finish, function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = url;
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand('copy');
          finish();
        } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  });

  /* ---------- YouTube facade ---------- */
  var vid = document.querySelector('[data-pt-video]');
  if (vid) {
    var vbtn = vid.querySelector('button');
    vbtn.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + vid.getAttribute('data-pt-video') + '?autoplay=1&rel=0';
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen = true;
      f.title = vbtn.getAttribute('aria-label') || 'Product video';
      vid.textContent = '';
      vid.appendChild(f);
    });
  }

  /* ---------- Mobile sticky bar: price + Buy now ---------- */
  var bar = root.querySelector('[data-pt-sticky]');
  if (bar) {
    var sectionId = root.getAttribute('data-section');
    var priceHost = document.getElementById('price-' + sectionId);
    var amount = bar.querySelector('[data-pt-sticky-price]');
    var mq = window.matchMedia('(max-width: 749px)');

    var syncPrice = function () {
      if (!priceHost || !amount) return;
      var el =
        priceHost.querySelector('.price-item--sale') ||
        priceHost.querySelector('.price-item--regular') ||
        priceHost.querySelector('.price-item');
      if (el && el.textContent.trim()) amount.textContent = el.textContent.trim();
    };

    var syncBar = function () {
      bar.hidden = !mq.matches;
      document.body.classList.toggle('pt-has-sticky', mq.matches);
    };

    syncPrice();
    syncBar();
    if (mq.addEventListener) mq.addEventListener('change', syncBar);
    if (priceHost && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(priceHost, { childList: true, subtree: true, characterData: true });
    }

    bar.querySelector('[data-pt-sticky-buy]').addEventListener('click', function () {
      if (checkbox && !checkbox.checked) {
        var wrap = document.getElementById('patoys-terms-wrapper');
        if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
        showTermsError();
        return;
      }
      var add = root.querySelector('.product-form__submit:not([disabled])');
      var buy = root.querySelector(
        '.shopify-payment-button__button:not([disabled]), [data-testid="Checkout-button"]'
      );
      var target = add || buy;
      if (target) target.click();
    });
  }
})();